import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionServicesInfoForm_ResolvableServiceUsage_Remove_Mutation =
  graphql(`
    mutation MissionServicesInfoForm_ResolvableServiceUsage_Remove(
      $serviceUsageId: Id!
      $serviceUserId: Id!
      $serviceUsagesGroupId: Id!
      $versionData: VersionDataInput
    ) {
      removeMissionServiceUsage(
        serviceUsageId: $serviceUsageId
        serviceUserId: $serviceUserId
        serviceUsagesGroupId: $serviceUsagesGroupId
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useRemoveMissionResolvableServiceUsageMutation = () =>
  useGraphQLMutation(
    MissionServicesInfoForm_ResolvableServiceUsage_Remove_Mutation,
  );
